resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function SessionTimeoutWarning() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];
  this._session = mogo.registry.Session || new Session();
  this.interval = null;
  this._analytics = null;

  this.init = function() {};

  this.initAllReady = function() {
    this.startCountdown();
    $(".js--refreshSession").on("click", $.proxy(this._refreshSession, this));
  };

  this.startCountdown = function() {
    var start = Date.now(),
      diff = 0,
      minutes = 0,
      seconds = 0,
      duration = this._session._SESSION_TIMEOUT_COUNTDOWN,
      min = $(".countdown--minutes", this.node),
      sec1 = $(".countdown--seconds-1", this.node),
      sec2 = $(".countdown--seconds-2", this.node),
      self = this;

    //Analytics event
    dataLayer.push({
      "event" : "DLevent.Logout",
      "Logout" : "Timeout warning"
    });

    var timer = function() {
      // get the number of seconds that have elapsed since
      // timer() was called
      diff = duration - (((Date.now() - start) / 1000) | 0);
      if (diff < 0) {
        clearInterval(self.interval);
        return;
      }

      // truncates the float
      minutes = (diff / 60) | 0;
      seconds = (diff % 60) | 0;

      //seconds = seconds < 10 ? "0" + seconds : seconds;

      min.text(minutes);
      sec1.text(Math.floor(seconds / 10));
      sec2.text(seconds % 10);

    };

    timer();
    this.interval = setInterval(timer, 1000);
  };

  this._refreshSession = function() {
    $("#session-timeout-dialog").mogo().hide();
    clearInterval(this.interval);
    this._session._refreshSession();
    this._session._resetTimer();
  };
}
